import { RouteType } from "../../../types/RouteType";

const CylinderTrackingWorkflowRoute: RouteType = {
  name: "Cylinder Tracking",
  path: "/workflows/cylinder-tracking",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./CylinderTrackingWorkflowHeader"),
      title: "Track Test Cylinders",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./CylinderTrackingWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async () => {
    return true;
  },
};

export default CylinderTrackingWorkflowRoute;
